



















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

import TitleBar from '@/components/Elements/TitleBar.vue';
import { STORE_KEY, store } from './_store';
import DbSyncConfigForm from './DbSyncConfigForm/DbSyncConfigForm.vue';
import DbSyncLogs from './DbSyncLogs/DbSyncLogs.vue';

@Component({
  components: { TitleBar },
  computed: {
    ...mapState(STORE_KEY, [
      'loading',
      'loaded',
      'fatalError',
      'documents',
      'lastMeta',
      'runningConfigId'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, {
      loadData: 'loadData',
      runSyncAction: 'runSync',
      toggleEnabledAction: 'toggleEnabled'
    })
  }
})
export default class DbSyncManager extends Vue {
  loading!: boolean;
  loaded!: boolean;
  fatalError!: boolean;
  documents!: any[];
  lastMeta!: any;
  runningConfigId!: number | null;
  loadData!: (query: any) => Promise<any>;
  runSyncAction!: (payload: { config: any; query: any }) => Promise<any>;
  toggleEnabledAction!: (payload: { document: any; query: any }) => Promise<any>;

  get titleStack() {
    return ['Настройки', 'Синхронизация БД'];
  }

  defaultSort = {
    field: 'schema_code',
    order: 'asc'
  };

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  created() {
    if (!(this.$store as any).hasModule(STORE_KEY)) {
      this.$store.registerModule(STORE_KEY, store);
    }
    this.loadData(this.queryParams);
  }

  beforeDestroy() {
    if ((this.$store as any).hasModule(STORE_KEY)) {
      this.$store.unregisterModule(STORE_KEY);
    }
  }

  @Watch('$route.query')
  onRouteQueryChanged(query: any) {
    this.loadData(query);
  }

  onPageChange(page: number) {
    this.$router.replace({ query: { ...this.queryParams, page: String(page) } });
  }

  onSort(field: string, order: string) {
    this.$router.replace({
      query: {
        ...this.queryParams,
        sortField: field,
        sortDirection: order === 'desc' ? 'desc' : 'asc'
      }
    });
  }

  runSync(config: any) {
    return this.runSyncAction({ config, query: this.queryParams });
  }

  toggleEnabled(document: any) {
    return this.toggleEnabledAction({ document, query: this.queryParams });
  }

  directionLabel(direction: string) {
    return direction === 'push' ? 'Выгрузка' : 'Загрузка';
  }

  transportLabel(transport: string) {
    return transport === 'api' ? 'HTTP API' : 'PostgreSQL (dblink)';
  }

  directionTagType(direction: string) {
    return direction === 'push' ? 'is-warning' : 'is-info';
  }

  strategyLabel(strategy: string) {
    return strategy === 'upsert' ? 'Upsert' : 'Полная замена';
  }

  statusLabel(status: string) {
    const map: Record<string, string> = {
      ok: 'Успех',
      error: 'Ошибка',
      running: 'Выполняется',
      never: 'Не запускалась'
    };
    return map[status] || status;
  }

  statusTagType(status: string) {
    const map: Record<string, string> = {
      ok: 'is-success',
      error: 'is-danger',
      running: 'is-warning',
      never: 'is-light'
    };
    return map[status] || 'is-light';
  }

  openForm(row: any) {
    this.$buefy.modal.open({
      parent: this,
      component: DbSyncConfigForm,
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      props: { documentId: row.id || null },
      events: {
        saved: () => this.loadData(this.queryParams)
      }
    });
  }

  openLogs(row: any) {
    this.$buefy.modal.open({
      parent: this,
      component: DbSyncLogs,
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      props: {
        configId: row.id,
        schemaCode: row.schema_code
      }
    });
  }
}
